// wishlist js

var wishListContainer = document.querySelector("#wishlist");

var isPageWishList = false;
if (wishListContainer) {
  isPageWishList = wishListContainer.getAttribute("data-page-wishlist");
  if (isPageWishList == "true") {
    isPageWishList = true;
  } else {
    isPageWishList = false;
  }
}

var LOCAL_STORAGE_WISHLIST_KEY = "shopify-wishlist";
var LOCAL_STORAGE_DELIMITER = ",";
var BUTTON_ACTIVE_CLASS = "active";
var GRID_LOADED_CLASS = "loaded";

var selectors = {
  button: "[button-wishlist]",
  grid: "[grid-wishlist]",
};

document.addEventListener("DOMContentLoaded", function () {
  initButtonsWishList();
  initGridWishList();
});

var styleWishlistPageRemoveButtons = function () {
  if (!isPageWishList) return;
  var label =
    wishListContainer.getAttribute("data-remove-text") ||
    (window.messNotifications && window.messNotifications.remove_from_wish_list) ||
    "إزالة من قائمة الرغبات";
  var iconTpl = document.getElementById("bambe-wishlist-remove-icon");
  document.querySelectorAll(".wishlist .button-wishlist").forEach(function (button) {
    button.classList.add("button-wishlist--remove", "active");
    button.setAttribute("aria-label", label);
    button.setAttribute("title", label);
    var tip = button.closest("[tooltip]");
    if (tip) tip.setAttribute("tooltip", label);
    if (iconTpl && iconTpl.content) {
      button.innerHTML = "";
      button.appendChild(iconTpl.content.cloneNode(true));
    }
  });
};

var setupGridWishList = function (grid) {
  var wishlist = getWishlist();
  var requests = wishlist.map(function (handle) {
    var productTileTemplateUrl = "/products/" + handle + "?view=card";
    return fetch(productTileTemplateUrl).then(function (res) {
      if (res.status == 200) {
        return res.text();
      }
    });
  });

  Promise.all(requests).then(function (responses) {
    var wishlistProductCards = responses.join("");

    if (!wishlistProductCards) {
      var iconLoading = grid
        .closest(".wishlist")
        .querySelector(".icon-loading-wishlist");
      iconLoading.classList.add("hidden");
      grid.classList.add("wishlist-empty");
      wishlistProductCards =
        (wishListContainer && wishListContainer.getAttribute("data-empty-text")) ||
        "لا توجد منتجات في قائمة الرغبات";
    }
    var iconLoading = grid
      .closest(".wishlist")
      .querySelector(".icon-loading-wishlist");
    iconLoading.classList.add("hidden");
    grid.innerHTML = wishlistProductCards;
    grid.classList.add(GRID_LOADED_CLASS);
    const grid_items = grid.querySelectorAll('.tp-prd-item');
    if (grid_items.length != 0) {
      grid_items.forEach(function (item) {
        item.classList.add('tp-grid__item');
      })
    }
    initButtonsWishList();
    styleWishlistPageRemoveButtons();
    var event = new CustomEvent("shopify-wishlist:init-product-grid", {
      detail: {
        wishlist: wishlist,
      },
    });
    document.dispatchEvent(event);
  });
};

var setupButtonsWishList = function (buttons) {
  buttons.forEach(function (button) {
    var productHandle = button.dataset.productHandle || false;
    if (!productHandle)
      return console.error(
        "[Shopify Wishlist] Missing `data-product-handle` attribute. Failed to update the wishlist."
      );
    if (wishlistContains(productHandle))
      button.classList.add(BUTTON_ACTIVE_CLASS);
  });
};

var initGridWishList = function () {
  var grid = document.querySelector(selectors.grid) || false;
  if (grid) setupGridWishList(grid);
};

var initButtonsWishList = function () {
  var buttons = document.querySelectorAll(selectors.button) || [];
  if (buttons.length) setupButtonsWishList(buttons);
  else return;
  var event = new CustomEvent("shopify-wishlist:init-buttons", {
    detail: {
      wishlist: getWishlist(),
    },
  });
  document.dispatchEvent(event);
};

var getWishlist = function () {
  var wishlist = localStorage.getItem(LOCAL_STORAGE_WISHLIST_KEY) || false;
  if (wishlist) return wishlist.split(LOCAL_STORAGE_DELIMITER);

  return [];
};

var setWishlist = function (array) {
  var wishlist = array.join(LOCAL_STORAGE_DELIMITER);
  if (array.length) localStorage.setItem(LOCAL_STORAGE_WISHLIST_KEY, wishlist);
  else localStorage.removeItem(LOCAL_STORAGE_WISHLIST_KEY);
  return wishlist;
};

var updateWishlist = function (handle) {
  var wishlist = getWishlist();
  var indexInWishlist = wishlist.indexOf(handle);
  if (indexInWishlist === -1) wishlist.push(handle);
  else wishlist.splice(indexInWishlist, 1);
  return setWishlist(wishlist);
};

var wishlistContains = function (handle) {
  var wishlist = getWishlist();
  return wishlist.indexOf(handle) !== -1;
};

var resetWishlist = function () {
  return setWishlist([]);
};

const handleCount = function () {
  const parent = document.querySelector(".tp-header-wishlist");
  if (!parent) return;
  const items = getWishlist();
  const numb = parent.querySelector(".wishlist-count");
  numb.innerText = items !== null && items.length != 0 ? items.length : 0;
};
handleCount();

document.addEventListener("click", function (e) {
  const button = e.target.closest(".button-wishlist");
  if (!button) return;

  // Ignore duplicate handling if nested handlers already consumed it
  if (button.dataset.wishlistBusy === "1") return;
  button.dataset.wishlistBusy = "1";
  setTimeout(function () {
    button.dataset.wishlistBusy = "0";
  }, 0);

  const productHandle = button.getAttribute("data-product-handle") || false;
  if (!productHandle) return;

  updateWishlist(productHandle);
  if (wishlistContains(productHandle)) {
    button.classList.add(BUTTON_ACTIVE_CLASS);
    if (window.showNotifications && window.messNotifications) {
      window.showNotifications(window.messNotifications.added_product_to_wish_list);
    }
    handleCount();
  } else {
    button.classList.remove(BUTTON_ACTIVE_CLASS);
    if (window.showNotifications && window.messNotifications) {
      window.showNotifications(window.messNotifications.removed_product_from_wish_list);
    }
    handleCount();

    if (isPageWishList) {
      const cardWrapper = button.closest(".tp-prd-item");
      cardWrapper && cardWrapper.remove();
      const docCardWrapper = document.querySelector(".wishlist .tp-prd-item");
      if (!docCardWrapper) {
        window.location.reload();
      }
    }
  }
});
